import PropTypes from 'prop-types';
import {
  routes,
  subRoutes,
  pathSearches,
  navGroups
} from '../../utils/constants/adminRoutes';
import NavMenu from './NavMenu';

/**
 * AdminNavMenu component.
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.setCollapsed - The set collapsed function.
 * @returns {JSX.Element} - The AdminNavMenu component.
 */
export const AdminNavMenu = ({ setCollapsed }) => (
  <NavMenu
    setCollapsed={setCollapsed}
    routes={routes}
    subRoutes={subRoutes}
    pathSearches={pathSearches}
    groups={navGroups}
  />
);

AdminNavMenu.propTypes = {
  setCollapsed: PropTypes.func.isRequired
};
